export const PLAY = "play";
export const PAUSE = "pause";
export const TOGGLE_PLAY_PAUSE = "toggle_play_pause";
export const NEW_SEGMENT_INDEX = "new_segment_index";
export const INCREMENT_SEGMENT_INDEX = "increment_segment_index";
export const NEW_BUFFER_SEGMENT = "new_buffer_segment";
export const NEW_BAR_INDEX = "new_bar_index";